import type { NotificationEntity } from "@/entities/notification";

import {
  isNotificationRead,
  useMarkNotificationAsRead,
} from "@/entities/notification";
import { useInvalidateNotifications } from "@/entities/notifications";
import {
  useIsNotificationOptimisticRead,
  useNotificationOptimisticRead,
} from "@/modules/notification/notification-optimistic-read";
import { useNotificationsView } from "@/modules/notifications/notifications-view";

export const useNotificationCard = (notification: NotificationEntity) => {
  const { view, isFetching, invalidateSuffixes } = useNotificationsView();
  const { invalidateNotifications } = useInvalidateNotifications();
  const { markAsRead } = useMarkNotificationAsRead();
  const { activateOptimisticRead, removeOptimisticRead } =
    useNotificationOptimisticRead();

  // Use optimistic read state to instantly mark the card as read
  const isRead = isNotificationRead(notification);
  const isOptimisticRead = useIsNotificationOptimisticRead(notification.id);
  const isUnread = isOptimisticRead ? false : !isRead;

  const isUnreadView = view === "unread_tab";
  const showPending = isUnreadView && isOptimisticRead && !isRead;

  const onSuccess = () => {
    invalidateNotifications(invalidateSuffixes);
  };

  const onError = () => {
    removeOptimisticRead(notification.id);
  };

  const onCardClick = () => {
    if (isRead) return;
    activateOptimisticRead(notification.id);
    markAsRead(notification.id, { onSuccess, onError });
  };

  return {
    isUnread,
    isPending: showPending ? isFetching : false,
    onCardClick,
  };
};
